import { round, formatDate } from '@btime/helpers'
import { YES_AND_NO_TYPES } from '@btime/constants'
import moment from 'moment'

export const clearName = string => (string ? string.replace(/\s/g, '').toLowerCase() : string)

export const getUserNames = serviceOrder => {
  const { user } = serviceOrder
  const registryNumber = user.fieldValues.find(
    fieldValue => fieldValue.field && fieldValue.field.name === 'Número do Registro'
  )
  return {
    userName: user.name,
    userCode: registryNumber ? registryNumber.value : 'N/A'
  }
}

export const getReplyValue = reply => {
  if (!reply) {
    return 'N/A'
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const getAddressValue = serviceOrder => {
  if (!serviceOrder.address) {
    const fieldFound = serviceOrder.place.fieldValues.find(fieldValue => fieldValue.field.name === 'Endereço')
    if (!fieldFound) {
      return '**N/A**'
    }
    return fieldFound.value.search
  }

  return serviceOrder.address.search
}

export const getCNPJValue = serviceOrder => {
  const fieldFound = serviceOrder.place.fieldValues.find(fieldValue => fieldValue.field.name === 'CNPJ')
  if (!fieldFound) {
    return '**N/A**'
  }
  return fieldFound.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByQuestionName = (replies, name) => {
  return replies.find(reply => reply.question.name === name)
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const findReplyByReference = (replies, reference) => {
  return replies.find(reply => reply.question.reference === reference)
}

export const findParentReply = (replies, reply) => {
  return replies.find(r => r.question.reference === reply.question.parentReference)
}

export const getReplyValueFieldOrDefault = (reply, field = 'value', defaultValue = '') => {
  if (!reply || reply[field] === undefined) {
    return defaultValue
  }
  return reply[field]
}

export const getDate = reply => {
  if (!reply) {
    return 'Não informada'
  }
  if (typeof reply === 'string') {
    return formatDate('DD/MM/YYYY', reply)
  }
  if (typeof reply === Date) {
    return formatDate('DD/MM/YYYY', reply)
  }
  return formatDate('DD/MM/YYYY', reply.value)
}

export const addBusinessDays = (originalDate, numDaysToAdd) => {
  const date = moment.isMoment(originalDate) ? originalDate : moment(originalDate)
  const sunday = 0
  const saturday = 6
  let daysRemaining = numDaysToAdd - 1

  const newDate = date.clone()

  while (daysRemaining > 0) {
    newDate.add(1, 'days')
    if (newDate.day() !== sunday && newDate.day() !== saturday) {
      daysRemaining--
    }
  }

  return newDate
}

export const toCurrency = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const getAssets = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const currencyToNumber = value => {
  if (!value) {
    return 0
  }
  if (typeof value == 'number') {
    return value
  }
  return Number(value.toString().replace(',', '#').replace('.', '').replace('#', '.'))
}

export const getFieldValue = (fields, fieldName) => {
  return fields.fieldValues.find(field => field.field.name === fieldName)
}

export const mountAssetsValues = replies => {
  const saida = {}
  replies.forEach(reply => {
    if (!saida[reply.blockIndex]) {
      saida[reply.blockIndex] = {}
    }
    const indexData = saida[reply.blockIndex]
    if (reply?.question?.type?.name === 'asset') {
      indexData.id = reply.value.id
      indexData[reply.question.name] = reply.value.name
    } else {
      indexData[reply.question.name] = reply.value
    }
  })
  return Object.values(saida)
}

export const checkNomCompliance = reply => {
  if (reply.question.nonComplianceConditions && reply.question.type.name === 'checkbox') {
    const { field, operator, value } = reply.question.nonComplianceConditions[0]
    if (operator === 'eq') {
      return reply[field] === value
    }
    return false
  }
  return false
}

export const calcPercent = (value, total) => {
  return round((value / total) * 100)
}

export const minMaxTable = () => {
  return {
    empty: { min: 0, max: 0 },
    'S101-10': { min: 670.38, max: 775.73 },
    'S111-25': { min: 776.79, max: 883.2 },
    'S126-50': { min: 884.27, max: 996.0 },
    'S151-100': { min: 1025.79, max: 1174.77 },
    'S1101-250': { min: 1175.83, max: 1320.55 },
    'S1251-500': { min: 1321.61, max: 1462.07 },
    'S1501-1000': { min: 1463.14, max: 1603.6 },
    'S1+de1000': { min: 1604.66, max: 1751.51 },
    'S201-10': { min: 1201.37, max: 1482.29 },
    'S211-25': { min: 1483.36, max: 1770.66 },
    'S226-50': { min: 1771.73, max: 2059.03 },
    'S251-100': { min: 2060.1, max: 2341.02 },
    'S2101-250': { min: 2342.08, max: 2629.39 },
    'S2251-500': { min: 2630.46, max: 2924.15 },
    'S2501-1000': { min: 2925.21, max: 3213.58 },
    'S2+de1000': { min: 3214.65, max: 3494.5 },
    'S301-10': { min: 1799.39, max: 2225.03 },
    'S311-25': { min: 2226.1, max: 2654.93 },
    'S326-50': { min: 2655.99, max: 3083.76 },
    'S351-100': { min: 3084.83, max: 3513.66 },
    'S3101-250': { min: 3514.72, max: 3956.32 },
    'S3251-500': { min: 3957.39, max: 4385.16 },
    'S3501-1000': { min: 4386.22, max: 4815.05 },
    'S3+de1000': { min: 4816.12, max: 5244.95 },
    'S401-10': { min: 2396.35, max: 2970.97 },
    'S411-25': { min: 2972.03, max: 3547.71 },
    'S426-50': { min: 3548.77, max: 4124.45 },
    'S451-100': { min: 4125.52, max: 4701.19 },
    'S4101-250': { min: 4702.26, max: 5265.17 },
    'S4251-500': { min: 5266.23, max: 5841.91 },
    'S4501-1000': { min: 5842.97, max: 6419.72 },
    'S4+de1000': { min: 6420.78, max: 6708.09 },
    'M101-10': { min: 402.23, max: 455.43 },
    'M111-25': { min: 456.5, max: 529.92 },
    'M126-50': { min: 530.99, max: 617.18 },
    'M151-100': { min: 618.24, max: 704.43 },
    'M1101-250': { min: 705.5, max: 791.69 },
    'M1251-500': { min: 792.75, max: 878.95 },
    'M1501-1000': { min: 880.01, max: 964.07 },
    'M1+de1000': { min: 965.14, max: 1053.46 },
    'M201-10': { min: 719.33, max: 892.78 },
    'M211-25': { min: 893.84, max: 1066.23 },
    'M226-50': { min: 1067.29, max: 1240.74 },
    'M251-100': { min: 1241.8, max: 1408.87 },
    'M2101-250': { min: 1409.93, max: 1577.0 },
    'M2251-500': { min: 1578.06, max: 1751.51 },
    'M2501-1000': { min: 1752.57, max: 1926.02 },
    'M2+de1000': { min: 1927.09, max: 2099.47 },
    'M301-10': { min: 1080.06, max: 1334.38 },
    'M311-25': { min: 1335.45, max: 1596.15 },
    'M326-50': { min: 1597.21, max: 1857.92 },
    'M351-100': { min: 1858.98, max: 2113.3 },
    'M3101-250': { min: 2114.37, max: 2367.62 },
    'M3251-500': { min: 2368.69, max: 2629.39 },
    'M3501-1000': { min: 2630.46, max: 2891.16 },
    'M3+de1000': { min: 2892.22, max: 3146.54 },
    'M401-10': { min: 1436.54, max: 1787.69 },
    'M411-25': { min: 1788.75, max: 2126.07 },
    'M426-50': { min: 2127.14, max: 2468.71 },
    'M451-100': { min: 2469.78, max: 2817.74 },
    'M4101-250': { min: 2818.8, max: 3166.76 },
    'M4251-500': { min: 3167.83, max: 3508.34 },
    'M4501-1000': { min: 3509.4, max: 3849.91 },
    'M4+de1000': { min: 3850.98, max: 4024.43 }
  }
}

export const countReplies = replies => {
  return replies.reduce(
    (counterObj, reply) => {
      const { value, question } = reply
      const type = question?.type?.name
      const affirmativeCount = YES_AND_NO_TYPES.includes(type) && value === true
      const negativeCount = YES_AND_NO_TYPES.includes(type) && value === false
      const hasNonCompliances = !!reply.question.nonComplianceConditions

      counterObj.affirmativeCount = counterObj.affirmativeCount + affirmativeCount
      counterObj.negativeCount = counterObj.negativeCount + negativeCount
      if (hasNonCompliances && negativeCount) {
        counterObj.nonCompliancesCount = counterObj.nonCompliancesCount + 1
      }
      return counterObj
    },
    { affirmativeCount: 0, negativeCount: 0, nonCompliancesCount: 0 }
  )
}
